"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  flex-basis: ", ";\n  flex-grow: 1;\n  max-width: 100%;\n  white-space: nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledToolBarGroup = _styledComponents.default.div.withConfig({
  displayName: "UIToolBarGroup__StyledToolBarGroup",
  componentId: "lb23yr-0"
})(_templateObject(), function (_ref) {
  var minimumWidth = _ref.minimumWidth;
  return minimumWidth ? (0, _Styles.toPx)(minimumWidth) + " !important" : '0%';
});

var UIToolBarGroup =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIToolBarGroup, _PureComponent);

  function UIToolBarGroup() {
    (0, _classCallCheck2.default)(this, UIToolBarGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIToolBarGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(UIToolBarGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "children"]);
      var computedClassName = (0, _classNames.default)('private-tool-bar__group', 'has--horizontal-spacing', className);
      return _react.default.createElement(StyledToolBarGroup, (0, _extends2.default)({}, rest, {
        className: computedClassName
      }), children);
    }
  }]);
  return UIToolBarGroup;
}(_react.PureComponent);

exports.default = UIToolBarGroup;
UIToolBarGroup.propTypes = {
  children: _react.PropTypes.node,
  minimumWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};
UIToolBarGroup.displayName = 'UIToolBarGroup';
module.exports = exports.default;